export const APPLIED_CASH_STRING = 'Applied CurbNTurf Cash';
export const APPLIED_AFFILIATE_REWARDS = 'Applied Affiliate Rewards';

export const DEFAULT_CHECK_IN_TIME = '14:00:00';
export const DEFAULT_CHECK_OUT_TIME = '12:00:00';
